import React from "react";
import Select from "react-select";
import { formatNumberWithCommas, formatDate } from "@/utils";
import { originOptions, transmissionOptions, displacementOptions, fuelRateOptions } from "@/constants/selectOptions";
import {
    useGetCarGubunQuery,
    useGetCarManufacturerQuery,
    useGetCarModelQuery,
    useGetCarModelDetailQuery,
    useGetCarClassQuery,
    useGetCarTrimQuery,
    useGetFuelListQuery,
} from "@/redux/metaApi";

export const VehicleInfo = ({ contract, onContractChange, handleSearchCar }) => {
    const contractCar = contract?.contractCar;
    const { data: carGubunData } = useGetCarGubunQuery();
    const carGubunOptions =
        carGubunData && carGubunData.data
            ? carGubunData.data.map((item) => ({
                  value: item.bgNo,
                  label: item.bgName,
              }))
            : [];
    const { data: manufacturerData } = useGetCarManufacturerQuery({ bmNo: null });
    const manufacturerOptions =
        manufacturerData?.data?.map((item) => ({
            value: item.bmNo,
            label: item.bmName,
        })) || [];
    const { data: modelData } = useGetCarModelQuery({ bmNo: contractCar?.bmNo }, { skip: !contractCar?.bmNo });
    const modelOptions =
        modelData?.data?.map((item) => ({
            value: item.boiNo,
            label: item.boiName,
        })) || [];
    const { data: detailModelData } = useGetCarModelDetailQuery({ boiNo: contractCar?.boiNo }, { skip: !contractCar?.boiNo });
    const detailModelOptions =
        detailModelData?.data?.map((item) => ({
            value: item.boNo,
            label: item.boName,
        })) || [];
    const { data: carClassData } = useGetCarClassQuery({ boNo: contractCar?.boiNo }, { skip: !contractCar?.boiNo });
    const carClassOptions =
        carClassData?.data?.map((item) => ({
            value: item.bsNo,
            label: item.bsName,
        })) || [];
    const { data: carTrimData } = useGetCarTrimQuery({ bsNo: contractCar?.bsNo }, { skip: !contractCar?.bsNo });
    const carTrimOptions =
        carTrimData?.data?.map((item) => ({
            value: item.bdNo,
            label: item.bdName,
        })) || [];
    const { data: fuelData } = useGetFuelListQuery();
    const fuelOptions =
        fuelData && fuelData.data
            ? fuelData.data.map((item) => ({
                  value: item.bfNo,
                  label: item.bfName,
              }))
            : [];

    return (
        <>
            {/* 차량번호 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        차량번호 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="carNumber"
                            placeholder=""
                            value={contractCar?.carNumber || ""}
                            onChange={(e) => onContractChange({ contractCar: { ...contractCar, carNumber: e.target.value } })}
                            disabled
                        />
                    </div>
                    <div className="form-element_button">
                        <button
                            type="button"
                            className="btn-form_element btn-outline"
                            onClick={() => {
                                handleSearchCar();
                            }}
                        >
                            선택
                        </button>
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3"></div>
            {/* 렌트사업자 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>렌트사업자</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="rentCorp.corpName"
                            value={contractCar?.rentCorp?.corpName || ""}
                            placeholder=""
                            onChange={(e) =>
                                onContractChange({
                                    contractCar: {
                                        ...contractCar,
                                        rentCorp: { ...contractCar.rentCorp, corpName: e.target.value },
                                    },
                                })
                            }
                            onInput={formatNumberWithCommas}
                            disabled
                        />
                    </div>
                </div>
            </div>
            {/* 본사 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>본사</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="rentCorp.address"
                            value={
                                contractCar?.rentCorp?.address
                                    ? `${contractCar?.rentCorp?.address} ${contractCar?.rentCorp?.addressDetail}`
                                    : ""
                            }
                            placeholder=""
                            onChange={(e) =>
                                onContractChange({
                                    contractCar: {
                                        ...contractCar,
                                        rentCorp: { ...contractCar.rentCorp, address: e.target.value },
                                    },
                                })
                            }
                            onInput={formatNumberWithCommas}
                            disabled
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            {/* 국산/수입 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>국산/수입</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={originOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="국산/수입"
                            value={originOptions.find((opt) => opt.value === contractCar?.cho)}
                            onChange={(option) => onContractChange({ contractCar: { ...contractCar, cho: option.value } })}
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            {/* 차종 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>차종</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            options={carGubunOptions}
                            isSearchable
                            placeholder="차종 선택"
                            value={carGubunOptions.find((opt) => opt.label === contractCar?.carGubun)}
                            onChange={(option) => onContractChange({ contractCar: { ...contractCar, carGubun: option.label } })}
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            {/* 제조사 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>제조사</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="제조사 선택"
                            options={manufacturerOptions}
                            value={manufacturerOptions.find((opt) => opt.value === contractCar?.bmNo)}
                            onChange={(option) =>
                                onContractChange({
                                    contractCar: {
                                        ...contractCar,
                                        bmNo: option.value,
                                        boiNo: "",
                                        boNo: "",
                                        bsNo: "",
                                        bdNo: "",
                                    },
                                })
                            }
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            {/* 모델 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>모델</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="모델 선택"
                            options={modelOptions}
                            value={modelOptions.find((opt) => opt.value === contractCar?.boiNo)}
                            onChange={(option) =>
                                onContractChange({
                                    contractCar: {
                                        ...contractCar,
                                        boiNo: option.value,
                                        boNo: "",
                                        bsNo: "",
                                        bdNo: "",
                                    },
                                })
                            }
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            {/* 상세모델 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>상세모델</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="상세모델 선택"
                            options={detailModelOptions}
                            value={detailModelOptions.find((opt) => opt.value === contractCar?.boNo)}
                            onChange={(option) =>
                                onContractChange({
                                    contractCar: { ...contractCar, boNo: option.value, bsNo: "", bdNo: "" },
                                })
                            }
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            {/* 등급 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>등급</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="등급 선택"
                            options={carClassOptions}
                            value={carClassOptions.find((opt) => opt.value === contractCar?.bsNo)}
                            onChange={(option) =>
                                onContractChange({
                                    contractCar: { ...contractCar, bsNo: option.value, bdNo: "" },
                                })
                            }
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            {/* 트림 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>트림</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="트림 선택"
                            options={carTrimOptions}
                            value={carTrimOptions.find((opt) => opt.value === contractCar?.bdNo)}
                            onChange={(option) => onContractChange({ contractCar: { ...contractCar, bdNo: option.value } })}
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            {/* 최초등록일 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>최초등록일</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        {/* <DatePicker
                            locale={ko}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={20}
                            selected={contractCar?.firstDate}
                            onChange={(date) =>
                                onContractChange({ contractCar: { ...contractCar, firstDate: dateFormatDateTime(date, "YYYY-MM-DD") } })
                            }
                            dateFormat="yyyy.MM.dd"
                            onKeyDown={(e) => e.preventDefault()}
                            disabled
                        /> */}
                        <input
                            type="text"
                            name="color"
                            placeholder=""
                            value={formatDate(contractCar?.firstDate)}
                            onChange={(e) => onContractChange({ contractCar: { ...contractCar, firstDate: e.target.value } })}
                            maxLength={10}
                            disabled
                        />
                    </div>
                </div>
            </div>
            {/* 외장색상 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>외장색상</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="color"
                            placeholder="화이트"
                            value={contractCar?.color || ""}
                            onChange={(e) => onContractChange({ contractCar: { ...contractCar, color: e.target.value } })}
                            disabled
                        />
                    </div>
                </div>
            </div>
            {/* 유종 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>유종</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={fuelOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="유종 선택"
                            value={fuelOptions.find((opt) => opt.label === contractCar?.fuel)}
                            onChange={(option) => onContractChange({ contractCar: { ...contractCar, fuel: option.label } })}
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            {/* 변속기 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>변속기</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={transmissionOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="변속기 선택"
                            value={transmissionOptions.find((opt) => opt.value === contractCar?.motorType)}
                            onChange={(option) => onContractChange({ contractCar: { ...contractCar, motorType: option.value } })}
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            {/* 배기량 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>배기량(cc)</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="배기량 선택"
                            options={displacementOptions}
                            value={displacementOptions.find((opt) => opt.value === contractCar?.displacement)}
                            onChange={(option) => onContractChange({ contractCar: { ...contractCar, displacement: option.value } })}
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            {/* 주행거리 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>주행거리(km)</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="mileage"
                            placeholder=""
                            value={contractCar?.mileage || ""}
                            onChange={(e) => onContractChange({ contractCar: { ...contractCar, mileage: e.target.value } })}
                            onInput={formatNumberWithCommas}
                        />
                        <span className="input-esset">km</span>
                    </div>
                </div>
            </div>
            {/* 유류량 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>유류량</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={fuelRateOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="유류량 선택"
                            value={fuelRateOptions.find((opt) => opt.value === contractCar?.gasCurrentAmount)}
                            onChange={(option) => onContractChange({ contractCar: { ...contractCar, gasCurrentAmount: option.value } })}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
